import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { MessageService } from "primeng/api";
import CommonUtils from "../utils/common.utils";

class NotificationOptions {
    message: string | undefined;
    sticky?: boolean;
    title?: string;
    duration?: number;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(
        private readonly messageService: MessageService,
        private readonly sanitizer: DomSanitizer
    ) { }

    success(options: NotificationOptions): string {
        return this.notify('success', options);
    }

    info(options: NotificationOptions): string {
        return this.notify('info', options);
    }

    warn(options: NotificationOptions): string {
        return this.notify('warn', options);
    }

    error(params: NotificationOptions | HttpErrorResponse): string {
        let opts: NotificationOptions;

    /*if ('error' in params && params.error.details) {
      opts = {
        ...params,
        message: params.error.details
      };
    } else */if ('error' in params && params.error?.message) {
            opts = {
                ...params,
                message: params.error.message
            };
        } else if ('message' in params && typeof params.message === 'string') {
            opts = {
                ...params,
                message: params?.message ?? undefined
            };
        } else {
            opts = {
                //message: params?.error?.message
                message: (params as HttpErrorResponse)?.error?.message
            };
        }

        if (opts.message == '' || !opts.message || opts.message == undefined) {
            opts.message = 'Something went wrong! Please try again.';
        }

        return this.notify('error', opts);
    }

    secondary(options: NotificationOptions): string {
        return this.notify('secondary', options);
    }

    clear(messageId?: string) {
        if (messageId) {
            this.messageService.clear(messageId);
        } else {
            this.messageService.clear();
        }
    }

    private notify(severity: string, options: NotificationOptions): string {
        this.messageService.clear();
        const msgId = CommonUtils.generateUniqueId().toString();

        this.messageService.add({
            id: msgId.toString(),
            severity: severity,
            summary: options.title,
            detail: options.message,
            closable: true,
            life: options.duration ?? 5000,
            sticky: options.sticky ?? false
        });

        return msgId;
    }

}